import { toast } from "react-toastify";
import axiosInstance from "../../../../axiosInstance";
import { HRMS_LMS_API_URL } from "../../../Constants/baseConstant";
import { getUserData, getUserId, getDomain } from "../../Base/helper/baseFunctions";
import NProgress from 'nprogress';

// Leave Overall Balance
export const GetLeaveOverallBalanceHelper = async (params) => {
    NProgress.start();
    toast.dismiss();
    params?.show !== "no" && toast.info("Loading...")
    return await axiosInstance(`/lms/getLeaveOverallBalance`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: getDomain(),
            emp_user_id: params?.emp_user_id || getUserId(),
        }
    })
        .then((res) => {
            toast.dismiss();
            NProgress.done();
            return { message: "Leave Overall Balance Retrieved Successfully", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            NProgress.done();
            return { message: "Unable to fetch Leave Overall Balance", hasError: false, data: err?.response?.data }
        })
}

// Pending Leave Approval
export const GetPendingLeaveApprovalHelper = async () => {
    var data = getUserData();
    toast.dismiss();
    return await axiosInstance(`/lms/getPendingApproval`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data.domain,
            emp_user_id: getUserId(),
        }
    })
        .then((res) => {
            toast.dismiss();
            return { message: "Pending Leave Approval Retrieved Successfully", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            return { message: "Unable to fetch Pending Leave Approval", hasError: false, data: err?.response?.data }
        })
}
